import React from 'react';
import { Box, Typography } from '@mui/material';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import { MiniGameFailure } from './types';
import { KEY_GUARD_ACTIVATE } from './keyGuard';
import { getOverlayStyles } from './overlayStyles';
import {
  MINI_GAME_BACK,
  MINI_GAME_FAILED_HEADLINE,
  MINI_GAME_FAILED_OTHER,
  MINI_GAME_FAILED_WEBGL,
} from './constants';

interface IFailureCardProps {
  classes: ReturnType<typeof getOverlayStyles>;
  failure: MiniGameFailure | null;
  onBack: () => void;
}

const FailureCard = ({ classes, failure, onBack }: IFailureCardProps) => (
  <Box
    sx={[classes.scrim, classes.failedScrim]}
    data-testid="myta-minigame-failed"
  >
    <Box sx={classes.card}>
      <SportsEsportsOutlinedIcon />
      <Typography component="h3" sx={classes.cardTitle}>
        {MINI_GAME_FAILED_HEADLINE}
      </Typography>
      <Typography component="p" sx={classes.cardText}>
        {failure === 'webgl' ? MINI_GAME_FAILED_WEBGL : MINI_GAME_FAILED_OTHER}
      </Typography>
      <Box sx={classes.cardActions}>
        <Box
          component="button"
          type="button"
          sx={classes.ghostBtn}
          onClick={onBack}
          autoFocus
          {...KEY_GUARD_ACTIVATE}
          data-testid="myta-minigame-back"
        >
          {MINI_GAME_BACK}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default FailureCard;
